import { z } from 'zod';

export const paginationSchema = z.object({
  itemsPerPage: z.number(),
  pageNumber: z.number(),
  totalItems: z.number(),
});

export const ingestionContextV1Schema = z.object({
  journeyId: z.number().nullable().optional(),
  journeyName: z.string().nullable().optional(),
  platformName: z.string().nullable().optional(),
});

export const ingestionContextV1StrictSchema = z.object({
  journeyId: z.number(),
  journeyName: z.string(),
  platformName: z.string().optional(),
});

export const ingestionContextV2Schema = z.object({
  mediaPlanId: z.string().nullable().optional(),
  mediaPlanName: z.string().nullable().optional(),
  activityId: z.string().nullable().optional(),
  activityName: z.string().nullable().optional(),
  platformName: z.string().nullable().optional(),
});

export const ingestionContextV2StrictSchema = z.object({
  mediaPlanId: z.string(),
  mediaPlanName: z.string(),
  activityId: z.string(),
  activityName: z.string(),
  platformName: z.string().optional(),
});

export const ingestionContextSchema = z.union([
  ingestionContextV1Schema,
  ingestionContextV2Schema,
]);

export const ingestionContextStrictSchema = z.union([
  ingestionContextV1StrictSchema,
  ingestionContextV2StrictSchema,
]);

export const granularityLevelSchema = z.enum([
  'pricing_item',
  'platform',
  'media_row',
  'platform_campaign',
]);

export type GranularityLevel = z.infer<typeof granularityLevelSchema>;
